import { Action } from "redux";

export const SET_LOADING = "SET_LOADING";

export interface LoadingAction extends Action<string> {
    isLoading: boolean;
}
